import { render, staticRenderFns } from "./upgrade-plan-modal.vue?vue&type=template&id=2cd34baf"
import script from "./upgrade-plan-modal.vue?vue&type=script&lang=js"
export * from "./upgrade-plan-modal.vue?vue&type=script&lang=js"
import style0 from "./upgrade-plan-modal.vue?vue&type=style&index=0&id=2cd34baf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports